// @flow
import * as React from 'react'
import ErrorPage from 'ui/organisms/ErrorPage'

function ResourceFillErrorPage(): React.Node {
  const refreshPage = () => {
    window.location.reload()
  }

  return (
    <ErrorPage
      buttonText="Refresh"
      heading="Something went wrong"
      onClick={refreshPage}
      text="Please refresh the page to try again"
    />
  )
}

export default ResourceFillErrorPage
